// Befund 35 — Brücke zwischen React-freiem Code (MutationCache in lib/queryClient.ts)
// und dem ToastProvider: der Provider registriert seine API beim Mounten, der
// MutationCache ruft sie ohne React-Kontext auf. Ohne registrierten Provider
// (z. B. in Unit-Tests einzelner Komponenten) ist der Aufruf ein No-Op.
import type { ToastApi } from '../components/Toast'

let api: ToastApi | null = null

export function registerGlobalToast(next: ToastApi | null): void {
  api = next
}

export function globalToastError(message: string): void {
  api?.error(message)
}
